import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutationChapterCreate } from 'gql/mutations/chapter';
import {
  mutationEditorChapterUpdate,
  mutationEditorFileImport,
  mutationEditorQuestionCreate,
  mutationEditorQuestionImport,
  mutationEditorQuestionTypeChange,
} from 'gql/mutations/editor';
import useHotkeys from 'hooks/useHotkeys';
import { trackEvent, reportError } from 'lib/tracking';
import { getQuestionsInfo } from 'questions';

import Actions from './Actions';

const ActionsContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const questionsInfo = getQuestionsInfo();
  const handleQuestionCreate = useCallback((type) => {
    mutationEditorQuestionCreate();
    if (type) {
      mutationEditorQuestionTypeChange(type);
    }
  }, []);
  const mutationChapterCreate = useMutationChapterCreate();
  const handleChapterCreate = useCallback(async () => {
    try {
      const {
        data: { chapterCreate },
      } = await mutationChapterCreate({
        courseId: course.id,
        title: t('Course/Teacher/Editor/Actions/new-chapter-title'),
      });
      mutationEditorChapterUpdate(chapterCreate);
      trackEvent('chapter', 'create');
    } catch (err) {
      reportError('chapter', 'create', err);
    }
  }, [course, mutationChapterCreate, t]);
  useHotkeys('shift+n', mutationEditorQuestionCreate);
  useHotkeys('shift+i', mutationEditorQuestionImport);
  useHotkeys('shift+c', handleChapterCreate);
  return (
    <Actions
      handleChapterCreate={handleChapterCreate}
      handleFileImport={mutationEditorFileImport}
      handleQuestionCreate={handleQuestionCreate}
      handleQuestionImport={mutationEditorQuestionImport}
      questionsInfo={questionsInfo}
      t={t}
      {...props}
    />
  );
};

ActionsContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default ActionsContainer;
